import { createElement as _createElement } from "react";
import { ComposerPastedTextFileNotice } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/ComposerPastedTextFileNotice.js';
import { useCallback, useState } from 'react';
export function useAskComposerPastedTextFile({ characterLimit, inputLength, }) {
    const [convertedFile, setConvertedFile] = useState(null);
    const [noticeKey, setNoticeKey] = useState(0);
    const dismissConversion = useCallback(() => setConvertedFile(null), []);
    const reset = useCallback(() => {
        setConvertedFile(null);
        // Submission also clears the trimmed notice and any retained file contents.
        setNoticeKey((current) => current + 1);
    }, []);
    const renderAttachmentNotice = useCallback((props) => (_createElement(ComposerPastedTextFileNotice, { ...props, key: noticeKey, characterLimit: characterLimit, convertedFile: convertedFile, inputLength: inputLength, onDismissConversion: dismissConversion })), [characterLimit, convertedFile, dismissConversion, inputLength, noticeKey]);
    return { reset, renderAttachmentNotice, showConversion: setConvertedFile };
}
//# sourceMappingURL=useAskComposerPastedTextFile.js.map